/* eslint-disable eqeqeq */
import React from 'react';
import { Image } from 'src/components';

import WZU from 'src/assets/images/notimage.png';
import LNX from 'src/assets/images/lnx.png';
import B2W from 'src/assets/images/b2w.png';
import MLB from 'src/assets/images/mlb.png';
import MZL from 'src/assets/images/mzl.png';
import SHO from 'src/assets/images/sho.png';
import VIA from 'src/assets/images/via.png';
import RNN from 'src/assets/images/ren.png';
import AMZ from 'src/assets/images/amz.png';
import NSH from 'src/assets/images/nsh.png';
import SHN from 'src/assets/images/shn.png';
import TIK from 'src/assets/images/tik.png';
import DFT from 'src/assets/images/dafiti.png';
import TRAY from 'src/assets/images/tray.png';

function PlatformSalesIcon({ platform, width, height, style = {}, alt }) {
  return (
    <Image
      style={{
        width,
        height,
        borderRadius: 5,
        ...style,
      }}
      src={
        platform == 'lnx' || platform == 'useebrasil.com.br' ? LNX
        : platform == 'b2w' || platform == '1' ?
          B2W
        : platform == 'mlb' || platform == '2' ?
          MLB
        : platform == 'mzl' || platform == '3' ?
          MZL
        : platform == 'sho' || platform == '5' ?
          SHO
        : platform == 'via' || platform == '6' ?
          VIA
        : platform == 'ren' || platform == '7' ?
          RNN
        : platform == 'amz' || platform == '8' ?
          AMZ
        : platform == 'nsh' || platform == '9' ?
          NSH
        : platform == 'shn' || platform == '12' ?
          SHN
        : platform == 'tkt' || platform == 'tts' || platform == '16' ?
          TIK
        : platform == 'dft' || platform == '24' ?
          DFT
        : platform == 'tray' || platform == '25' ?
          TRAY
        : WZU
      }
      alt={alt ?? platform}
    />
  );
}

export default PlatformSalesIcon;
